import { jsx } from "react/jsx-runtime";
import React from "react";
var arrow_pair_squarepath_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { d: "M16.172 7.2427H7c-.5523 0-1 .4477-1 1v4H4v-4c0-1.6569 1.3431-3 3-3h9.1721l-1.8285-1.8285L15.7578 2l4.2426 4.2426-4.2426 4.2427-1.4142-1.4142 1.8284-1.8284zM9.6564 20.5858l-1.828-1.828H17c1.6568 0 3-1.3431 3-3v-4h-2v4c0 .5523-.4477 1-1 1H7.8275l1.8289-1.8289-1.4142-1.4142-4.2427 4.2427L8.2422 22l1.4142-1.4142z" })];
};
export {
  arrow_pair_squarepath_default as default
};
